import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import {
  UpdateMultiProductOptionsBuyProductIDBody,
  ProductOptionApi,
} from 'api';

export const createProductOption = createAsyncThunk(
  'productOption/create',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await ProductOptionApi.create(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateMultiProductOptionsBuyProductID = createAsyncThunk(
  'productOption/updateMultiProductOptionsBuyProductID',
  async (
    body: UpdateMultiProductOptionsBuyProductIDBody,
    { rejectWithValue }
  ) => {
    try {
      const response = await ProductOptionApi.updateMulti(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateProductOption = createAsyncThunk(
  'productOption/update',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await ProductOptionApi.update(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const removeProductOption = createAsyncThunk(
  'productOption/remove',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await ProductOptionApi.remove(id);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface State {
  list: Array<any>;
}

const initialState: State = {
  list: [],
};

const productOptionSlice = createSlice({
  name: 'productOption',
  initialState,
  reducers: {},
  extraReducers: {},
});

const { reducer: productOptionReducer } = productOptionSlice;

export default productOptionReducer;
